export default function ({commit}, value) {
    commit('value',value);
}